import { useUser } from '@/lib/auth';

/**
 * 이 폴더가 내 것인가. CTA 패널, 행 메뉴, 히어로 카드의 편집 진입이 모두 이 판정을 본다.
 *
 * ⚠️ SSR 은 인증 헤더 없이 렌더하므로 첫 페인트에서는 항상 false 다.
 * 소유자 전용 UI 는 하이드레이션 뒤에 나타난다.
 */
export const useIsFolderOwner = (ownerId: string | undefined) => {
  const { user } = useUser();

  return !!user?.quizUserId && !!ownerId && user.quizUserId === ownerId;
};
